/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getReferenceableSyncEntities} from '../api'

 export const useQueryGetReferenceableSyncEntities = createReactQueryHook('getReferenceableSyncEntities', getReferenceableSyncEntities)
